// removed by extract-text-webpack-plugin
module.exports = {"container":"container-P2XJ4","modal":"modal-3n7xG","radiocheck":"radiocheck-MeDL6","check":"check-4J2-d","input":"input-1SumI","labels":"labels-3i2sj","number":"number-1Wid_","right":"right-2KtLL","label":"label-3YO4O","button":"button-1XgFN btn-3FsRe","button-input":"button-input-2wW0K","upload":"upload-1zurZ","doc":"doc-3o7Rk","btn":"btn-2xxSQ btn-3FsRe","prefix":"prefix-2XvTl","input-date":"input-date-2FK88","label-date":"label-date-3mMJ4","inputlarge":"inputlarge-1WiYs"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/components/order-vtt-kupavna/style.scss
 ** module id = 164
 ** module chunks = 0
 **/